import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { useFeatureBadge } from '../../hooks/useFeatureBadge';

// 既読フラグキー: アップデートごとに新しい値にすれば未読扱いで再表示できる
const UPDATE_KEY = 'ui_update_2026_07_29_car_nickname';

interface CarNickname {
  nickname: string;
  model: string;
  number: string;
}

// 呼称一覧（2026-07-29 時点。車両呼称一覧.xlsx より）
const carNicknames: CarNickname[] = [
  { nickname: '北川ハイエース', model: 'ハイエース', number: '5393' },
  { nickname: '設備エルフ', model: 'エルフ', number: '6272' },
  { nickname: 'むっつり配川号', model: 'ハイエース', number: '6281' },
  { nickname: '虫色号', model: 'ハイエース', number: '6416' },
  { nickname: 'トムさん', model: 'エルフ', number: '1063' },
  { nickname: 'LZ', model: 'エルフ', number: '2244' },
  { nickname: '茶ダブ', model: 'エルフ', number: '4315' },
  { nickname: 'ミツダブ', model: 'デュトロ', number: '5198' },
  { nickname: 'キャラバン', model: 'キャラバン', number: '6532' },
  { nickname: '福キャン', model: 'キャンター', number: '4464' },
  { nickname: '4ｔデュトロ', model: 'デュトロ', number: '3225' },
  { nickname: '肉丸号', model: 'ハイエース', number: '290' },
  { nickname: 'ファイター', model: 'ファイター', number: '8122' },
  { nickname: '赤ユニック', model: 'レンジャー', number: '925' },
  { nickname: 'トッポイ', model: 'レンジャー', number: '3131' },
  { nickname: 'フォン', model: 'プリウス', number: '6637' },
  { nickname: '黒プリウス', model: 'プリウス', number: '38' },
  { nickname: '亀エルフ', model: 'エルフ', number: '8230' },
  { nickname: 'スギトロ', model: 'デュトロ', number: '8111' },
  { nickname: '会長プリウス', model: 'プリウス', number: '1985' },
  { nickname: '黒ユニック', model: 'フォワード', number: '8790' },
  { nickname: '銀ユニック', model: 'フォワード', number: '8613' },
  { nickname: '福田', model: 'ノア', number: '818' },
];

export const WhatsNewDialog: React.FC = () => {
  const { isNew, markSeen } = useFeatureBadge(UPDATE_KEY);

  return (
    <Dialog
      open={isNew}
      onClose={markSeen}
      maxWidth="sm"
      fullWidth
      disableRestoreFocus
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <DirectionsCarIcon color="primary" />
        車両の選び方が変わりました
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 1 }}>
          予定・日報の車両選択が、車種名から<strong>社内呼称</strong>での表示に変わりました。
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          売却などで使われていない車両は選択肢に表示されなくなりました。
          呼称と車両の対応は以下のとおりです。
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>呼称</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>これまでの表示</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {carNicknames.map((car) => (
              <TableRow key={car.nickname}>
                <TableCell>{car.nickname}</TableCell>
                <TableCell>{`${car.model} ${car.number}`}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={markSeen} variant="contained" fullWidth>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
